var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDeletebasket = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.5 3.4A1.6 1.6 0 0 1 15.1 5v.7h3.4a.6.6 0 1 1 0 1.2h-13a.6.6 0 1 1 0-1.2h3.4V5a1.6 1.6 0 0 1 1.6-1.6h3Zm-3 1.2a.4.4 0 0 0-.4.4v.7h3.8V5a.4.4 0 0 0-.4-.4h-3ZM17.952 7.9a1.1 1.1 0 0 1 1.096 1.176l-.567 8.174a3.595 3.595 0 0 1-3.583 3.35H9.032a3.595 3.595 0 0 1-3.585-3.381l-.495-8.153A1.098 1.098 0 0 1 6.047 7.9h11.905Zm-11.31 9.245c.077 1.267 1.12 2.198 2.385 2.199h5.867c1.258 0 2.306-.92 2.393-2.178l.355-7.948H6.347l.295 7.927Zm3.879.355H9.298l-.155-7h1.359l.019 7Zm4.173 0h-1.222l.014-7h1.359l-.15 7Z",
  fill: "#000"
})));
export default SvgDeletebasket;